"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueToBool_1 = __importDefault(require("../lib/valueToBool"));
const registries_1 = require("../registries");
registries_1.functionRegistry.set('w', (context, args) => {
    let result = '';
    while (valueToBool_1.default(context.getValueOfVariable(args[0]))) {
        result += context.getValueOfVariable(args[1]);
    }
    return result;
});
